module.exports = __webpack_public_path__ + "static/media/bg-discover-2.0c98c31a.svg";